import styled from 'styled-components';

export default styled.p`
  font-size: 14px;
  color: ${props => props.textColor || '#666'};
`;
